import { reactive, computed } from 'vue';
import {buildTimestamp, version} from "@/version.js";

const env = import.meta.env.VITE_ENVIRONMENT || '';
const buildLocalTime = new Date(buildTimestamp).toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
}).replace(',', '');

// State variables
export const systemInfo = reactive({
    appName: 'BGN TV',
    version: version,
    env: env,
    buildTimestamp: buildLocalTime || '...',
    prizeData: {},
    handshakeSettings: {},
    handshakeInfo: {},

    test: {
        testLine1: "test line 1",
        testNestedObject: {
            testNestedObjectLine1: "test nested object line 1",
            testNestedObjectLine2: "test nested object line 2",
            testNestedObjectLine3: "test nested object line 3",
        },
        testLine2: "test line 2"
    },
    state: {
        current: 'offline',
        last: 'none'
    },
    screen: `${window.innerWidth}x${window.innerHeight}`
    // -- List of variables that can be expected to be populated automatically --
    // broadcastId: null,
    // broadcastId_offset: 0,
    // // siteId: '',
    // playerToken: null,
    // rmq: null,
    // siteType: 0,
    // schedule: null,
    // siteCity: "",
    // siteName: "",
    // siteState: "",
    // siteZip: "",
    // statusId: "",
    // login: "",
    // lastScheduledGameTime: "",
    // serialNumber: "",
    // networkConnected: false,
    // initialized: false,
    // prizeEnabled: false
});

export const loggingInfo = computed(() => ({
    serialNumber: systemInfo.serialNumber,
    siteName: systemInfo.handshakeInfo.siteName,
    siteId: systemInfo.siteId,
    version: systemInfo.version,
    state: systemInfo?.state?.current
}));

// Parameters used in multiple places throughout app
export const params = {
    backgroundSrc: 'blade_background-med_blur.webm', // App background video source file
    startupWait: 1,                 // Time in S to wait at startup screen before proceeding to home screen
    cols: 5,                        // Number of grid columns
    autoLaunchTimeout: 120,         // Time in S before default app launches
    modalTimeout: 20,               // Time in S before modals auto close
    menuTimeout: 60,                // Time in S before menu auto close
    appStartTimeout: 30,            // Time in S to wait to timeout app launch -- communication failure
    thxTimeout: 60,                 // Time in S to wait before going back to home screen after hosted game ends
    dimTimeout: 5,                  // Time in S before UI dims -- to be nice to OLED displays
    gameIdInputTime: 120,           // Time in S for host to enter game ID before returning to home screen
    gameIdValidationTimeout: 30000, // Time in MS to wait to timeout game ID validation
    communicationAttemptRetries: 5, // Number of times to retry sending system info
    baseRetryDelay: 2,              // Time in S to progressively back off retries
}
